import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SubWebsocketMessageRequest } from '@qtek/core/websockets-core';
import {
  DocumentTemplate,
  EntityMeta,
  ITemplateData,
  TemplateDataHistory,
  TemplateTypes,
} from '@qtek/shared/models';

export const DocumentTemplatesActions = createActionGroup({
  source: 'Document Templates',
  events: {
    'Connect Document Templates': props<{
      payload?: Partial<Omit<SubWebsocketMessageRequest, 'ent' | 'op'>>;
    }>(),
    'Disconnect Document Templates': emptyProps(),
    'Query Document Templates Success': props<{
      documentTemplates: DocumentTemplate[];
      meta?: EntityMeta;
    }>(),
    'Query Document Templates Failure': props<{ error: Error }>(),
    'Create Document Templates': props<{
      documentTemplateName: string;
      documentTemplateType: TemplateTypes;
    }>(),
    'Create Document Templates Success': props<{
      documentTemplate: DocumentTemplate;
    }>(),
    'Create Document Templates Failure': props<{ error: Error }>(),
    'Update Document Templates': props<{
      documentTemplateName: string;
      documentTemplateId: string;
    }>(),
    'Update Document Templates Success': props<{
      payload: DocumentTemplate;
    }>(),
    'Update Document Templates Failure': props<{ error: Error }>(),
    'Delete Document Templates': props<{
      documentTemplateId: string;
    }>(),
    'Delete Document Templates Success': props<{
      documentTemplateId: string;
    }>(),
    'Delete Document Templates Failure': props<{ error: Error }>(),
    'Connect To Template': props<{
      payload: { view: string; id: string; mysid: string; s: string };
    }>(),
    'Disconnect From Template': emptyProps(),

    'Connect Template Data': props<{
      payload: {
        prms: { id: string };
        s: string;
        tmpId: string;
      };
    }>(),
    'Disconnect Template Data': emptyProps(),

    'Get Template Data': props<{
      id: string;
      dealId?: string;
    }>(),
    'Get Template Data Success': props<{
      templateData: ITemplateData;
    }>(),
    'Get Template Data Failure': props<{
      error: Error;
    }>(),

    'Create Document Template Data': props<{
      tplId: string;
    }>(),

    'Update Document Templates Data': props<{
      id: string;
      res: Partial<ITemplateData>;
    }>(),

    'Get Last Published Template Data': props<{
      id: string;
    }>(),
    'Get Last Published Template Data Success': props<{
      templateData: ITemplateData;
    }>(),
    'Get Last Published Template Data Failure': props<{
      error: Error;
    }>(),

    'Get Template Data History': props<{
      id: string;
    }>(),
    'Get Template Data History Success': props<{
      templateDataHistory?: TemplateDataHistory;
    }>(),
    'Get Template Data History Failure': props<{
      error: Error;
    }>(),
  },
});
